import './Preview.css'
import RenderImage, { RenderImageProps } from '../components/RenderImage'
import RenderImage2, { RenderImage2Props } from '../components/RenderImageSec'

import { useAppSelector } from '../hooks'
import { selectForm, selectPage } from '../slices/formSlice'
import { selectInitialized } from '../slices/mediaSlice'

export interface PreviewProps {
    displayAlways?: boolean
    svgRef1?: RenderImageProps['svgRef']
    svgRef2?: RenderImage2Props['svgRef']
}

function Preview({ displayAlways = false, svgRef1, svgRef2 }: PreviewProps) {
    const { statement, name, age, origin, image } = useAppSelector(selectForm)
    const initialized = useAppSelector(selectInitialized)
    const page = useAppSelector(selectPage)

    if (page > 2 && !displayAlways) {
        return <></>
    }

    return (
        <>
            {!initialized && <div className="spin"></div>}
            {initialized && (
                <div className="preview-container">
                    <div className="preview-item">
                        <RenderImage
                            statement={statement}
                            name={name}
                            age={age}
                            origin={origin}
                            image={image}
                            svgRef={svgRef1}
                        />
                    </div>
                    <div className="preview-item">   
                        <RenderImage2
                            statement={statement}
                            name={name}
                            age={age}
                            origin={origin}
                            image={image}
                            svgRef={svgRef2}
                        />
                    </div>                    
                </div>
            )}
        </>
    )
}

export default Preview